import { render, staticRenderFns } from "./CustomerBOL.vue?vue&type=template&id=653de9cc&scoped=true"
import script from "./CustomerBOL.vue?vue&type=script&lang=js"
export * from "./CustomerBOL.vue?vue&type=script&lang=js"
import style0 from "./CustomerBOL.vue?vue&type=style&index=0&id=653de9cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653de9cc",
  null
  
)

export default component.exports